'use strict';

// Core modules — always loaded
import externalLinks from './external_links';
import { init as mastheadMenuInit } from './masthead-menu';
import { init as cookiePolicyInit } from './cookie_policy';
import { init as cartInit } from './cart';
import emo from './emo';

export function init() {
    document.addEventListener('DOMContentLoaded', () => {
        externalLinks();
        emo();
        cookiePolicyInit();
        mastheadMenuInit();
        cartInit();

        // Page-specific modules — dynamically imported, code-split automatically
        // Vite names chunks by filename: gallery.js → gallery-[hash].js
        const body = document.body.classList;

        if (document.querySelector('.js-gallery')) {
            import('./gallery').then(({ init }) => init());
        }

        if (body.contains('template_home')) {
            import('./home_grid').then(({ init }) => init());
        }

        if (body.contains('template_seria')) {
            import('./seria').then(({ init }) => init());
        }

        if (body.contains('template_checkout')) {
            import('./checkout').then(({ init }) => init());
        }

        if (body.contains('template_contacts')) {
            import('./form_contact').then(({ init }) => init());
        }

        if (body.contains('template_contacts_office')) {
            import('./googleMap').then(({ init }) => init());
        }
    });
}
